import * as React from "react";
import { Navbar } from "react-bootstrap";

import { navbarColor } from "../../../lib/navbar-color";

export const NoMenuNavigationBar = () => {
	return (
		<Navbar bg={navbarColor} variant="dark" expand="lg" className="px-3">
			<Navbar.Brand href="#home" className="fw-bold">
				Test it
			</Navbar.Brand>
		</Navbar>
	);
};
